<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="文章详情"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:'首页'}
      ,{path:'/articles',breadcrumbName:'文章列表'}
      ,{path:`/articles/${articleId}`,breadcrumbName:'文章详情'}
      ] } }"
    />
    <div style="margin: 16px">
      <a-row :gutter="20">
        <a-col :span="8">
          <a-card :bordered="false">
            <a-form-model ref="form" :model="form.data" :rules="form.rules">
              <a-form-model-item label="标题" prop="title">
                <a-input v-model="form.data.title"/>
              </a-form-model-item>
              <a-form-model-item label="副标题" prop="subTitle">
                <a-input v-model="form.data.subTitle"/>
              </a-form-model-item>
              <a-form-model-item label="描述" prop="subTitle">
                <a-textarea v-model="form.data.description" :rows="4"/>
              </a-form-model-item>
              <a-form-model-item label="分类" prop="type">
                <dict-select v-model="form.data.type" dict-code="INDEX_POSTER_TYPE"/>
              </a-form-model-item>
              <a-form-model-item label="上传封面" prop="coverPath">
                <div slot="label">
                  上传封面
                  <span class="help-tip">(750*1448)</span>
                </div>
                <div class="a-input">
                  <simple-uploader v-model="form.data.coverPath"/>
                </div>
              </a-form-model-item>
              <a-form-model-item label="视频" v-if="form.data.type==='VIDEO'" prop="videoPath">
                <span
                  class="help-tip"
                  slot="extra"
                  style="cursor: pointer"
                      @click="reviewVideo">预览</span>
                <div class="a-input">
                  <simple-uploader v-model="form.data.videoPath" :type="form.data.type"/>
                </div>
              </a-form-model-item>
              <a-form-model-item label="跳转目标">
                <goods-series-select v-model="form.data.targetId"/>
              </a-form-model-item>
              <a-form-model-item>
                <a-space>
                  <a-button type="primary" v-if="!articleId" @click="onAdd">创建</a-button>
                  <a-button type="primary" v-if="articleId" @click="onUpdate">更新</a-button>
                  <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
                </a-space>
              </a-form-model-item>
            </a-form-model>
          </a-card>
        </a-col>
        <a-col :span="16">
          <a-col :span="14">
            <a-card style="height: calc(100vh - 190px)">
              <div class="article-wrap">
                <article-detail-wrap
                  v-for="(detail,index) in form.data.details"
                  :key="`detail-${index}`"
                  :detail="detail"
                  @click="editDetail(index)"
                  @onUp="onDetailUp(index)"
                  @onDown="onDetailDown(index)"
                  @onRemove="onDetailRemove(index)"
                >
                </article-detail-wrap>
              </div>
              <div style="width: 375px;margin: 0 auto;">
                <a-button type="dashed" block @click="addArticleDetail" style="margin-top: 20px">
                  ADD
                </a-button>
              </div>
            </a-card>
          </a-col>
          <a-col :span="10">
            <a-card v-if="articleDetailForm.visible">
              <a-form-model ref="articleForm" :model="articleDetailForm.data">
                <a-form-model-item
                  v-if="!articleDetailForm.data.type"
                  label="请选择分类">
                  <dict-select
                    v-model="articleDetailForm.data.type"
                    dict-code="ARTICLE_DETAIL_TYPE"/>
                </a-form-model-item>
                <a-form-model-item
                  v-if="articleDetailForm.data.type === 'IMAGE'"
                  label="图片">
                  <simple-uploader ref="detailImgUploader" v-model="articleDetailForm.data.image"/>
                </a-form-model-item>
                <a-form-model-item
                  v-if="articleDetailForm.data.type === 'GOODS'"
                  label="商品">
                  <img-goods-select v-model="articleDetailForm.data.targetId"/>
                </a-form-model-item>
                <a-form-model-item>
                  <a-space>
                    <a-button type="primary" @click="saveArticleDetail">确认</a-button>
                    <a-button type="primary" @click="cancelArticleDetail">取消</a-button>
                  </a-space>
                </a-form-model-item>
              </a-form-model>
            </a-card>
          </a-col>
        </a-col>
      </a-row>
    </div>
    <a-modal
            :footer="null"
             append-to-body
             title="视频预览"
             v-model="video.visible">
      <video
        v-if="video.visible"
        ref="video"
        webkit-playsinline="true"
        playsinline="true"
        x-webkit-airplay="true"
        x5-video-player-type="h5"
        x5-video-player-fullscreen="true"
        x5-video-orientation="portraint"
        style="width: 100%;height: auto"
        autoplay
        preload="auto"
        muted="true"
        :src="form.data.videoPath"
      >您的浏览器不支持HTML5
      </video>
    </a-modal>
  </div>
</template>

<script>
import { _addArticle, _queryArticle, _updateArticle } from '@/api/articleApi';
import DictSelect from '@/components/DictSelect.vue';
import SimpleUploader from '@/components/SimpleUploader.vue';
import ArticleDetailWrap from '@/views/cms/article/components/ArticleDetailWrap.vue';
import ImgGoodsSelect from '@/components/contentSelector/ImgGoodsSelect.vue';
import GoodsSeriesSelect from '@/components/contentSelector/GoodsSeriesSelect';

async function getArticle() {
  const result = await _queryArticle(this.articleId);
  if (result) {
    this.form.data.title = result.title;
    this.form.data.subTitle = result.subTitle;
    this.form.data.description = result.description;
    this.form.data.type = result.type;
    this.form.data.coverPath = result.coverPath;
    this.form.data.videoPath = result.videoPath;
    this.form.data.details = result.details;
    this.form.data.jumpType = result.jumpType;
    this.form.data.targetId = result.targetId;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addArticle({
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        description: this.form.data.description,
        type: this.form.data.type,
        coverPath: this.form.data.coverPath,
        videoPath: this.form.data.videoPath,
        jumpType: this.form.data.jumpType,
        targetId: this.form.data.targetId,
        details: this.form.data.details,
      });
      if (result) {
        this.$message.success('添加成功');
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateArticle(this.articleId, {
        title: this.form.data.title,
        subTitle: this.form.data.subTitle,
        description: this.form.data.description,
        type: this.form.data.type,
        coverPath: this.form.data.coverPath,
        videoPath: this.form.data.videoPath,
        jumpType: this.form.data.jumpType,
        targetId: this.form.data.targetId,
        details: this.form.data.details,
      });
      if (result) {
        this.$message.success('更新成功');
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

function reviewVideo() {
  if (this.form.data.videoPath) {
    this.video.visible = true;
  }
}

function addArticleDetail() {
  if (!this.articleDetailForm.visible) {
    this.articleDetailForm.visible = true;
  }
}

function saveArticleDetail() {
  if (this.articleDetailForm.data.type === 'IMAGE') {
    const style = this.$refs.detailImgUploader.getSize();
    this.articleDetailForm.data.style = JSON.stringify(style);
  }
  this.form.data.details = [...this.form.data.details, { ...this.articleDetailForm.data }];
  this.articleDetailForm.data = {
    index: null,
    type: null,
    name: '',
    richText: '',
    text: '',
    style: '',
    images: '',
    image: '',
    video: '',
    title: '',
    subTitle: '',
    description: '',
    targetId: '',
    targetType: '',
  };
  this.articleDetailForm.visible = false;
}

function cancelArticleDetail() {
  this.articleDetailForm.data = {
    index: null,
    type: null,
    name: '',
    richText: '',
    text: '',
    style: '',
    images: '',
    image: '',
    video: '',
    title: '',
    subTitle: '',
    description: '',
    targetId: '',
    targetType: '',
  };
  this.articleDetailForm.visible = false;
}

function editDetail(index) {
  this.articleDetailForm.data = this.form.data.details[index];
  this.articleDetailForm.data.index = index;
  this.articleDetailForm.visible = true;
}

function onDetailUp(index) {
  if (index === 0) {
    return;
  }
  this.form.data.details.splice(index - 1, 0, (this.form.data.details[index]));
  this.form.data.details.splice(index + 1, 1);
  this.form.data.details = [...this.form.data.details];
}

function onDetailDown(index) {
  if (index === (this.form.data.details.length - 1)) {
    return;
  }
  // 在下一项插入该项
  this.form.data.details.splice(index + 2, 0, (this.form.data.details[index]));
  // 删除前一项.
  this.form.data.details.splice(index, 1);
  this.form.data.details = [...this.form.data.details];
}

function onDetailRemove(index) {
  this.form.data.details = this.form.data.details.filter((x, i) => i !== index);
}

export default {
  name: 'ArticleEdit',
  components: {
    GoodsSeriesSelect,
    ImgGoodsSelect,
    ArticleDetailWrap,
    SimpleUploader,
    DictSelect,
  },
  props: {
    articleId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    articleId() {
      if (this.articleId) {
        this.getArticle();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getArticle,
    reviewVideo,
    addArticleDetail,
    saveArticleDetail,
    cancelArticleDetail,
    onDetailUp,
    onDetailDown,
    onDetailRemove,
    editDetail,
  },
  data() {
    return {
      video: {
        visible: false,
        url: '',
      },
      articleDetailForm: {
        visible: false,
        data: {
          index: null,
          type: null,
          name: '',
          richText: '',
          text: '',
          style: '',
          images: '',
          image: '',
          video: '',
          title: '',
          subTitle: '',
          description: '',
          targetId: '',
          targetType: '',
        },
      },
      form: {
        data: {
          title: '',
          subTitle: '',
          description: '',
          type: '',
          coverPath: '',
          videoPath: '',
          jumpType: 'GOODS_SERIES',
          targetId: '',
          details: [],
        },
        rules: {
          title: [{ required: true, trigger: 'blur' }],
          subTitle: [{ required: true, trigger: 'blur' }],
          type: [{ required: true, trigger: 'blur' }],
          coverPath: [{ required: true, trigger: 'blur' }],
          videoPath: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.articleId) {
      this.getArticle();
    }
  },
};
</script>
<style scoped>
.article-wrap {
  background: #f0f2f5 url('../../../assets/preview-header.png') no-repeat;
  background-size: contain;
  width: 375px;
  margin: 0 auto;
  height: 667px;
  overflow-y: auto;
  padding-top: 64px;
  box-shadow: #d0d0d0 0 0 11px 3px;
}

::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}

/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: none;
  background-color: rgba(69, 69, 69, 0.0);
  border-radius: 0px;
  display: none;
}

/*定义滑块颜色、内阴影及圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 0px;
  -webkit-box-shadow: none;
  background-color: rgba(69, 69, 69, 0.1);
}

/*定义两端按钮的样式*/
::-webkit-scrollbar-button {
  background-color: rgba(69, 69, 69, 0.0);
  display: none;
}

/*定义右下角汇合处的样式*/
::-webkit-scrollbar-corner {
  background: khaki;
}
</style>
